import update from "immutability-helper";
import { get, forEach } from "lodash";

import {
  EVENTS_REQUEST,
  RECEIVE_EVENT_GROUPS,
  RECEIVE_CHILD_EVENT_GROUPS,
  RECEIVE_EVENTS,
  EVENTS_FAILED,
} from "../constants/actionTypes";

const events = (state = {}, action) => {
  switch (action.type) {
    case EVENTS_REQUEST:
      return update(state, {
        isFetching: { $set: !action.child },
        fetchingChild: { $set: action.child },
      });
    case RECEIVE_EVENT_GROUPS:
      return update(state, {
        isFetching: { $set: false },
        failed: { $set: false },
        eventGroups: { $set: action.eventGroups },
        total: { $set: action.total },
      });
    case RECEIVE_CHILD_EVENT_GROUPS:
      return update(state, {
        fetchingChild: { $set: false },
        failed: { $set: false },
        eventGroups: {
          $set: addChildEventGroups(
            state.eventGroups,
            action.parentId,
            action.childEventGroups
          ),
        },
      });
    case RECEIVE_EVENTS:
      return update(state, {
        isFetching: { $set: false },
        failed: { $set: false },
        allEvents: { $set: action.events },
        total: { $set: action.total },
      });
    case EVENTS_FAILED:
      return update(state, {
        isFetching: { $set: false },
        failed: { $set: true },
      });
    default:
      return state;
  }
};

const addChildEventGroups = (eventGroups, parentId, childEventGroups) => {
  forEach(eventGroups, (e) => {
    if (get(e, ["id"]) === parentId) {
      e.childEventGroups = childEventGroups;
    }
  });
  return eventGroups;
};

export default events;
